const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video streaming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M113.4,111.754H80.559a34.468,34.468,0,0,0-34.611,34.731V342.938H78.785V146.485A34.468,34.468,0,0,1,113.4,111.754Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.785,365.283v-12.21H45.948v12.21c0,19.308,15.3,35.464,34.611,35.464H113.4C94.088,400.747,78.785,384.591,78.785,365.283Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.441,102.75H391a6,6,0,0,0,0,12h47.441A23.272,23.272,0,0,1,461.688,138V342.971H50.312V138A23.272,23.272,0,0,1,73.559,114.75H121a6,6,0,0,0,0-12H73.559A35.287,35.287,0,0,0,38.312,138V375.673A35.287,35.287,0,0,0,73.559,410.92H194.052v71.83H166.111a6,6,0,0,0,0,12H351.152a6,6,0,1,0,0-12h-33.2V410.92H438.441a35.287,35.287,0,0,0,35.247-35.247V138A35.287,35.287,0,0,0,438.441,102.75Zm-132.493,380h-99.9V410.92h99.9Zm132.493-83.83H73.559a23.273,23.273,0,0,1-23.247-23.247v-20.7H461.688v20.7A23.273,23.273,0,0,1,438.441,398.92Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.926,276.767a6,6,0,0,0-6,6v34.32a6,6,0,0,0,12,0v-34.32A6,6,0,0,0,252.926,276.767Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.926,257.652a6,6,0,0,0-12,0v3.915a6,6,0,0,0,12,0Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.463,285.694a6,6,0,0,0-6,6v15.393a6,6,0,0,0,12,0V291.694A6,6,0,0,0,204.463,285.694Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.463,247.652a6,6,0,0,0-12,0v22.717a6,6,0,0,0,12,0Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39,276.369a6,6,0,0,0-6,6v34.718a6,6,0,0,0,12,0V282.369A6,6,0,0,0,301.39,276.369Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.39,247.652a6,6,0,1,0-12,0v13.717a6,6,0,0,0,12,0Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.853,250.3a6,6,0,0,0-6,6v25.181a6,6,0,0,0,12,0V256.3A6,6,0,0,0,349.853,250.3Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.853,227.652a6,6,0,0,0-12,0v9.574a6,6,0,0,0,12,0Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,258.085a6,6,0,0,0-6,6v23a6,6,0,0,0,12,0v-23A6,6,0,0,0,156,258.085Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,227.652a6,6,0,0,0-12,0v14.786a6,6,0,0,0,12,0Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,17.25H141a26.029,26.029,0,0,0-26,26v149a26.029,26.029,0,0,0,26,26H371a26.029,26.029,0,0,0,26-26v-149A26.029,26.029,0,0,0,371,17.25Zm-230,12H371a14.015,14.015,0,0,1,14,14V166.29H223.1a22.2,22.2,0,0,0-42.741,0H127V43.25A14.015,14.015,0,0,1,141,29.25Zm70.928,143.04a10.2,10.2,0,1,1-10.2-10.2A10.212,10.212,0,0,1,211.928,172.29ZM371,206.25H141a14.015,14.015,0,0,1-14-14V178.29h53.357a22.2,22.2,0,0,0,42.741,0H385v13.96A14.015,14.015,0,0,1,371,206.25Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.254,117.42a6,6,0,0,0,6.2-.38l25.92-17.927a6,6,0,0,0,0-9.869l-25.92-17.927a6,6,0,0,0-9.413,4.935v35.853A6,6,0,0,0,240.254,117.42ZM249.04,87.7l9.372,6.482-9.372,6.481Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,143.379a49.2,49.2,0,1,0-49.2-49.2A49.256,49.256,0,0,0,250.6,143.379Zm0-86.4a37.2,37.2,0,1,1-37.2,37.2A37.242,37.242,0,0,1,250.6,56.979Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.3be5e6472a254d8b9855eefaa185cad4.svg";
export { ForwardRef as ReactComponent };